import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'App/components/Table/Table';
import TherigyLoadingSpinner from 'App/components/TherigyLoadingSpinner';
import usePatientRecordSections from 'App/hooks/usePatientRecordSections';
import useFetchPatientRecordData from './useFetchPatientRecordData';
import './PatientRecord.scss';

const PatientRecord = () => {
    const { tabs, isLoading } = usePatientRecordSections();

    return (
        <div className="patient-navigation-container">
            {isLoading && (
                <div className="patient-navigation-status patient-navigation-loading">
                    <TherigyLoadingSpinner />
                </div>
            )}

            {!isLoading && tabs.length === 0 && (
                <div className="patient-navigation-status patient-navigation-empty">
                    No patient chart sections are enabled for this branch.
                </div>
            )}

            {!isLoading && tabs.length > 0 && <PatientRecordTabs tabs={tabs} />}
        </div>
    );
};

const PatientRecordTabs = ({ tabs }) => {
    const [activeKey, setActiveKey] = useState(tabs[0].eventKey);
    const { data: visibleData = [] } = useFetchPatientRecordData(activeKey);

    return (
        <Tabs
            id="patient-navigation-tabs"
            activeKey={activeKey}
            onSelect={setActiveKey}
            className="mb-3 patient-navigation"
        >
            {tabs.map((tab) => (
                <Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}>
                    <div className="tab-content">
                        {tab.render ? (
                            tab.render(visibleData)
                        ) : (
                            <Table
                                key={tab.eventKey}
                                columns={tab.columns}
                                data={visibleData}
                                initialState={tab.initialState}
                                enablePagination={false}
                                className="patient-record-table"
                            />
                        )}
                    </div>
                </Tab>
            ))}
        </Tabs>
    );
};

PatientRecordTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            eventKey: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            render: PropTypes.func,
            columns: PropTypes.arrayOf(
                PropTypes.shape({
                    Header: PropTypes.string,
                    accessor: PropTypes.string,
                    sortType: PropTypes.func,
                    disableFilters: PropTypes.bool,
                    Cell: PropTypes.func,
                })
            ),
            initialState: PropTypes.shape({
                sortBy: PropTypes.arrayOf(
                    PropTypes.shape({
                        id: PropTypes.string,
                        desc: PropTypes.bool,
                    })
                ),
            }),
        })
    ).isRequired,
};

export default PatientRecord;
